/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function initQuoteSync() {
  var cartCountEl = document.querySelector('.header__action-item--cart .header__cart-count');
  var quoteCountEl = document.querySelector('.header__action-item--quote .header__cart-count');

  if (!cartCountEl || !quoteCountEl) {
    return false; // Elements not ready in DOM yet
  }

  var syncQuoteContent = function () {
    // 1. Sync the badge count
    var newCount = cartCountEl.textContent.trim();
    quoteCountEl.textContent = newCount;
    if (newCount === '') {
      quoteCountEl.style.setProperty('display', 'none', 'important');
    } else {
      quoteCountEl.style.removeProperty('display');
    }

    // 2. Sync the items list
    var sourceContent = document.querySelector('#mini-cart .mini-cart__content');
    var targetContent = document.querySelector('#mini-quote .mini-cart__content');
    if (sourceContent && targetContent) {
      targetContent.innerHTML = sourceContent.innerHTML;
    }

    // 3. Sync total price
    var sourceTotal = document.querySelector('#mini-cart .mini-cart__recap-price-line');
    var targetTotal = document.querySelector('#mini-quote .mini-cart__recap-price-line');
    if (sourceTotal && targetTotal) {
      targetTotal.innerHTML = sourceTotal.innerHTML;
    }

    // 4. Sync empty vs filled states
    var sourceEmpty = document.querySelector('#mini-cart .mini-cart__content--empty');
    var targetEmpty = document.querySelector('#mini-quote .mini-cart__content--empty');
    var targetInner = document.querySelector('#mini-quote .mini-cart__inner');

    if (sourceEmpty) {
      if (targetInner) targetInner.style.display = 'none';
      if (!targetEmpty) {
        var emptyDiv = document.createElement('div');
        emptyDiv.className = 'mini-cart__content mini-cart__content--empty';
        emptyDiv.innerHTML = '<div class="mini-cart__empty-state"><svg class="icon icon--quote" viewBox="0 0 24 24" style="fill: none; height: 40px; width: auto;"><path d="M9.5 21H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9l6 6v3" stroke="currentColor" stroke-width="2" fill="none"></path><path d="M13 2v6h6" stroke="currentColor" stroke-width="2" fill="none"></path></svg><p class="heading h5" style="margin-top: 15px; text-transform: none; margin-bottom: 5px;">Agrega productos al carrito para crear tu cotización.</p><p class="heading h6" style="text-transform: none; margin-top: 8px; font-weight: normal; color: #6c757d;">Te enviaremos un PDF al correo ingresado.</p></div><a href="/collections/all" class="button button--primary button--full">Ver productos</a>';
        document.querySelector('#mini-quote').appendChild(emptyDiv);
      } else {
        // If targetEmpty exists, let's also update its text just to be safe
        var emptyState = targetEmpty.querySelector('.mini-cart__empty-state');
        if (emptyState) {
          emptyState.innerHTML = '<svg class="icon icon--quote" viewBox="0 0 24 24" style="fill: none; height: 40px; width: auto;"><path d="M9.5 21H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9l6 6v3" stroke="currentColor" stroke-width="2" fill="none"></path><path d="M13 2v6h6" stroke="currentColor" stroke-width="2" fill="none"></path></svg><p class="heading h5" style="margin-top: 15px; text-transform: none; margin-bottom: 5px;">Agrega productos al carrito para crear tu cotización.</p><p class="heading h6" style="text-transform: none; margin-top: 8px; font-weight: normal; color: #6c757d;">Te enviaremos un PDF al correo ingresado.</p>';
        }
        var targetButton = targetEmpty.querySelector('.button');
        if (targetButton) {
          targetButton.textContent = 'Ver productos';
        }
        targetEmpty.style.display = '';
      }
    } else {
      if (targetEmpty) targetEmpty.style.display = 'none';
      if (targetInner) targetInner.style.display = '';
    }
  };

  // Observe count mutations
  var observer = new MutationObserver(function () {
    syncQuoteContent();
  });

  observer.observe(cartCountEl, { characterData: true, childList: true, subtree: true });

  // Observe mini-cart modifications
  var miniCartEl = document.querySelector('#mini-cart');
  if (miniCartEl) {
    observer.observe(miniCartEl, { childList: true, subtree: true });
  }

  // Lógica para alternar el desplegable al hacer clic en el ícono de cotización (abre el popover en lugar de navegar de inmediato)
  var quoteToggle = document.querySelector('.header__action-item--quote .header__action-item-link');
  var miniQuote = document.querySelector('#mini-quote');

  if (quoteToggle && miniQuote) {
    quoteToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var isActive = miniQuote.classList.toggle('is-active');
      miniQuote.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    // Manejar clics en el slideshow 'slideshow_tRVdg4' para activar el cotizador flotante
    var slideshowCotizador = document.querySelector('#shopify-section-slideshow_tRVdg4');
    if (slideshowCotizador) {
      slideshowCotizador.style.cursor = 'pointer';
      slideshowCotizador.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var isActive = miniQuote.classList.toggle('is-active');
        miniQuote.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    // También manejar slides generales que representen al 'Cotizador' para asegurar un comportamiento robusto
    var cotizarSlides = document.querySelectorAll('.slideshow__slide');
    cotizarSlides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (img && (img.src.includes('Cotizador') || (img.dataset.srcset && img.dataset.srcset.includes('Cotizador')) || (img.alt && img.alt.includes('Cotizador')))) {
        slide.style.cursor = 'pointer';
        slide.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var isActive = miniQuote.classList.toggle('is-active');
          miniQuote.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }
    });

    document.addEventListener('click', function (event) {
      var isSlideshowCotizarClick = false;
      if (slideshowCotizador && slideshowCotizador.contains(event.target)) {
        isSlideshowCotizarClick = true;
      }
      var clickedCotizarSlide = event.target.closest('.slideshow__slide');
      if (clickedCotizarSlide) {
        var img = clickedCotizarSlide.querySelector('img');
        if (img && (img.src.includes('Cotizador') || (img.dataset.srcset && img.dataset.srcset.includes('Cotizador')) || (img.alt && img.alt.includes('Cotizador')))) {
          isSlideshowCotizarClick = true;
        }
      }

      if (!miniQuote.contains(event.target) && !quoteToggle.contains(event.target) && !isSlideshowCotizarClick) {
        miniQuote.classList.remove('is-active');
        miniQuote.setAttribute('aria-hidden', 'true');
      }
    });
  }

  syncQuoteContent();
  return true; // ¡Inicializado con éxito!
}

// Arrancar la ejecución de manera robusta
(function () {
  var attempts = 0;
  var maxAttempts = 30; // 3 segundos en total en el caso extremo

  function tryInit() {
    if (initQuoteSync()) {
      console.log('Quote dropdown initialized successfully.');
    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(tryInit, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();